// extracted by mini-css-extract-plugin
module.exports = {"field":"src_field__XDtNv","todo":"src_todo__fGy8z","sidebar":"src_sidebar__UTEJp","toDoTasks":"src_toDoTasks__1bNbj"};